import { render } from "./SectionActivityLog.vue?vue&type=template&id=22ef7872&scoped=true"
import script from "./SectionActivityLog.vue?vue&type=script&lang=js"
export * from "./SectionActivityLog.vue?vue&type=script&lang=js"

import "./SectionActivityLog.vue?vue&type=style&index=0&id=22ef7872&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ef7872"]])

export default __exports__